import Vue from 'vue';

import DashboardPlugin from './plugins/dashboard-plugin';

import './filters/filters' // global filter

// Storage setup
import VueStorage from 'vue-ls';
import store from './store/' //store
// router setup
import router from "./routes/starterRouter";

import i18n from './i18n';

import './registerServiceWorker'
// Vue.use(VueResource);
import http from './http'

// Setup authentication and ACL
import './auth'

import '@mdi/font/css/materialdesignicons.css'
import App from './App.vue';

let storageOptions = {
  namespace: 'abt_admin__',
  name: 'ls',
  storage: 'local'
}
Vue.use(VueStorage, storageOptions)

// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  http,
  router,
  store,
  i18n,
  render: h => h(App),
});
